import { getParam } from '@tencent/midas-util'
import Api from '@/api/index'
/**
 * 获得页面 url 上的 pf 值
 */
export const getPf = () => getParam('pf')

/**
 * 获得页面的 appid (offerId)
 */
export const getAppid = () => getParam('appid') || '1450013518'

/**
 * 获得页面 url 上的 sandbox 的值
 */
export const getEnv = () => getParam('sandbox') * 1

/**
 * 获得版本号内容
 */
export const getVersion = (): string => getParam('version') || 'MidasFulizhuanquDefaultVersion1.0'

/**
 * 根据 getEnv 得到 url 前缀
 */
export const getPrefix = (): string => {
  const env = getEnv()

  if (env === 1 || env === 2) {
    return 'sandbox.'
  }

  return ''
}

/**
 * 初始化 cgi object
 * @param session
 */
export const initApi = (session: Object) => {
  Api.init({
    appid: getAppid(),
    pf: getPf(),
    sandbox: getEnv(),
    sessionObj: session,
    version: getVersion()
  })
}

export const isUndef = (v: unknown): v is undefined | null => v === undefined || v === null

/**
 *判断时间是否在有效期内
 */
export function checkTimeValid(
  begin?: string | number | Date,
  end?: string | number | Date
): boolean {
  if (isUndef(begin) || isUndef(end)) return false
  const now = new Date().getTime()

  const beginTime = new Date(begin).getTime()
  const endTime = new Date(end).getTime()

  return beginTime <= now && now <= endTime
}
